import { JobsActionTypes } from './constants';

export const INIT_STATE = {
    loading: false,
    jobs: [],
    streamConnected: false,
    streamError: null,
};

const MAX_TRACKED_JOBS = 50;

const getDateValue = (value) => (value ? new Date(value).getTime() : 0);

const mergeJobs = (currentJobs, incomingJobs) => {
    const map = new Map();
    currentJobs?.forEach((job) => {
        if (job?.id) {
            map.set(job.id, job);
        }
    });

    const updates = Array.isArray(incomingJobs) ? incomingJobs : [incomingJobs];

    updates?.forEach((job) => {
        if (!job || !job.id) {
            return;
        }
        const existing = map.get(job.id) || {};
        map.set(job.id, { ...existing, ...job });
    });

    const ordered = Array.from(map.values()).sort(
        (a, b) =>
            getDateValue(b.updatedAt || b.completedAt || b.createdAt) -
            getDateValue(a.updatedAt || a.completedAt || a.createdAt)
    );

    return ordered.slice(0, MAX_TRACKED_JOBS);
};

type JobsAction = {
    type: string,
    payload: { actionType?: string, data?: any, error?: string, job?: any, jobId?: string },
};

const Jobs = (state = INIT_STATE, action: JobsAction): any => {
    switch (action.type) {
        case JobsActionTypes.API_RESPONSE_SUCCESS:
            switch (action.payload.actionType) {
                case JobsActionTypes.GET_JOBS:
                    return { ...state, loading: false, jobs: mergeJobs([], action.payload.data) };
                default:
                    return { ...state, loading: false };
            }

        case JobsActionTypes.API_RESPONSE_ERROR:
            switch (action.payload.actionType) {
                case JobsActionTypes.GET_JOBS:
                    return { ...state, loading: false, error: action.payload.error };
                default:
                    return { ...state, loading: false, error: action.payload.error };
            }

        case JobsActionTypes.GET_JOBS:
            return { ...state, loading: true };

        case JobsActionTypes.JOB_STREAM_UPDATE:
            return { ...state, jobs: mergeJobs(state.jobs, action.payload.job) };

        case JobsActionTypes.JOB_STREAM_DELETE:
            return { ...state, jobs: state.jobs.filter((job) => job.id !== action.payload.jobId) };

        case JobsActionTypes.JOB_STREAM_CONNECTED:
            return { ...state, streamConnected: true, streamError: null };

        case JobsActionTypes.JOB_STREAM_DISCONNECTED:
            return { ...state, streamConnected: false };

        case JobsActionTypes.JOB_STREAM_ERROR:
            return { ...state, streamError: action.payload.error };

        default:
            return { ...state };
    }
};

export default Jobs;
